"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = require("../icons");
var grid_1 = require("./grid");
var Stars = function () { return (react_1.default.createElement(grid_1.Container, { center: true }, __spreadArray([], Array(5), true).map(function (_, idx) { return (react_1.default.createElement(icons_1.Star, { key: "star-".concat(idx) })); }))); };
exports.default = Stars;
//# sourceMappingURL=Stars.js.map